import {PersistStorage, StorageValue} from 'zustand/middleware';
import {AccountDataStore} from './types';

const customStorage: PersistStorage<AccountDataStore> = {
	getItem: (
		name,
	): StorageValue<AccountDataStore> | Promise<StorageValue<AccountDataStore> | null> | null => {
		const item = localStorage.getItem(name);
		if (!item) return null;

		return {
			state: {
				accountData: JSON.parse(item),
			} as AccountDataStore,
			version: 0,
		};
	},
	setItem: (name, value) => {
		localStorage.setItem(name, JSON.stringify(value.state.accountData));
	},
	removeItem: name => {
		localStorage.removeItem(name);
	},
};

export {customStorage};
